export default __webpack_public_path__ + "static/media/landing_page_bim_gis_integration.9a180829.gif";